<template>
  <div class="d-flex justify-content-between flex-column">
    <div div class="row justify-content-end mb-5">
      <div class="col-12">
        <p class="text-primary text-small font-weight-bold mb-2">
          {{ trans("courses.word-hunter.step") }} {{ currentStep }}.
        </p>
        <h4 class="text-primary mt-0 mb-3" tabindex="0">
          {{ trans("courses.word-hunter.words_match") }}
        </h4>
        <p class="font-weight-bold mb-3" id="subTitle">
          {{ trans("courses.word-hunter.words_match_desk") }}
        </p>
        <div class="border-light rounded-big px-4 pt-4 pb-2 mb-3">
          <div class="mx-2 mb-3" v-for="(keyword, key) in selectedWords" :key="key">
            <span class="font-weight-bold text-small mr-3">{{ key + 1 }}.</span>
            {{ keyword.word }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <b-form-select
          v-model="selected"
          :options="options"
          @change="selectTopic"
          aria-labelledby="subTitle"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between w-100">
          <b-button @click="$emit('prev')" variant="link">{{
            trans("courses.word-hunter.back")
          }}</b-button>
          <b-button @click="onClickNext" :disabled="selected === null">{{
            trans("courses.word-hunter.next")
          }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WordTopicMatch",
  props: {
    selectedWords: Array,
    currentStep: Number,
    selectedTopicId: Number,
    topicList: Array,
    trackingData: Object,
  },
  data() {
    return {
      selected: null,
    };
  },
  methods: {
    onClickNext() {
      trackEvent("WordhunterStep2", this.trackingData);
      this.$emit("next");
    },
    selectTopic(selectedOption) {
      this.$emit("selectTopic", selectedOption);
      trackEvent("WordhunterChooseTopics", { promptId: this.trackingData.promptId });
    },
  },
  mounted() {
    this.selected = this.selectedTopicId;
  },
  computed: {
    options() {
      const optionsList = this.topicList.map((topic, index) => ({
        text: topic.name,
        id: index + 1,
        value: topic.id,
      }));
      optionsList.unshift({
        text: this.trans("courses.word-hunter.words_match_sub"),
        value: null,
        id: 0,
      });
      return optionsList;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .btn-group-vertical {
    > .btn {
      &:not(.dropdown-toggle) {
        margin-bottom: $spacer;
        text-align: left;
        border-radius: 4px;
        color: $color-dark;
        padding-top: $spacer;
        padding-bottom: $spacer;
        font-weight: normal;
      }
      &.active {
        color: $color-white;
      }
    }
  }
}
</style>
